export const listPageOrder = [
  "Let's Get Started",
  'Estimated Available Equity',
  'View My Offer',
  'Personal Information',
  'Employment Information',
  'Demographic Information',
  'Declarations',
  'Inquiry Summary',
  'Completion',
];

export const getSidebarPageOrder = (hasDeclarations: boolean, isLpGateway: boolean): string[] =>
  listPageOrder.filter((page) => (hasDeclarations || page !== 'Declarations') && (!isLpGateway || page !== 'Personal Information'));

export const pageNameToConfigIndex: { [key: string]: number } = {
  "Let's Get Started": 0,
  'Estimated Available Equity': 2,
  'View My Offer': 3,
  'Personal Information': 6,
  'Employment Information': 7,
  'Demographic Information': 8,
  Declarations: 9,
  'Inquiry Summary': 10,
  Completion: 11,
};

export const routeToPageIndex: { [key: string]: number } = {
  '/get-started': 0,
  '/get-started-address': 0,
  '/estimated-available-equity': 2,
  '/vmo': 3,
  '/vmo-line-amount': 3,
  '/vmo-draw-amount': 3,
  '/personal-information': 6,
  '/employment-information': 7,
  '/government-monitoring-information': 8,
  '/declarations': 9,
  '/inquiry-summary': 10,
  '/completion': 11,
};
